import { render, staticRenderFns } from "./PlatformFinance.vue?vue&type=template&id=25ac1fdd"
import script from "./PlatformFinance.vue?vue&type=script&lang=js"
export * from "./PlatformFinance.vue?vue&type=script&lang=js"
import style0 from "./PlatformFinance.vue?vue&type=style&index=0&id=25ac1fdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports